// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unpaid-bills td {
  vertical-align: middle;
}

.customer-name {
  font-weight: 500;
  line-height: 0.9rem;
}

.customer-email {
  font-weight: 300;
  color: #888;
  line-height: 0.9rem;
  font-size: 0.75rem;
}

/* Compact and Polished Invoice Styles */
.invoice-details.compact {
  padding: 15px;
  font-size: 0.9em;
  color: #333;
}

.invoice-header h3 {
  font-size: 1.2em;
  margin: 0 0 5px 0;
}

.customer-details h4 {
  font-size: 1em;
  color: #0056b3;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.invoice-link .btn {
  font-size: 0.85em;
  padding: 3px 8px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.orders .order {
  border: 1px solid #eee;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 4px;
}

.order-body {
  display: flex;
}

.order-image img {
  max-height: 100px;
  width: auto;
  margin-right: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.order-info p {
  margin: 4px 0;
}

.order-lines.compact {
  font-size: 0.85em;
}

.order-lines th, .order-lines td {
  padding: 4px 6px;
  text-align: left;
}

.order-lines th {
  background-color: #f8f9fa;
}

.invoice-totals p {
  font-weight: bold;
  font-size: 1em;
  margin: 4px 0;
}

.invoice-totals p strong {
  width: 150px;
  display: inline-block;
}

.payment-result {
  margin: 10px;
  border: 1px solid orange;
  background-color: #781721;
  color: white;
  padding: 10px;
  display: flex;
}

.payment-result-header {
  width: 100%;
  text-align: center;
  padding: 5px;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .invoice-details.compact {
    font-size: 0.8em;
  }
  .invoice-header h3 {
    font-size: 1em;
  }
  .invoice-totals p strong {
    width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/accounts/invoices/invoices.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EAAiB,gBAAA;EAAkB,mBAAA;AAGnC;;AAFA;EAAkB,gBAAA;EAAkB,WAAA;EAAa,mBAAA;EAAqB,kBAAA;AAStE;;AALA,wCAAA;AAEA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;AAOF;;AAJA;EACE,gBAAA;EACA,iBAAA;AAOF;;AAJA;EACE,cAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAOF;;AAJA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAOF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,iBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,gBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;AAOF;;AAJA;EACE,YAAA;EACA,qBAAA;AAOF;;AAJA;EACE,YAAA;EACA,wBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAOF;;AAJA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAOF;;AAJA;EACE;IACE,gBAAA;EAOF;EAJA;IACE,cAAA;EAMF;EAHA;IACE,YAAA;EAKF;AACF","sourcesContent":[".unpaid-bills td {\n  vertical-align: middle;\n}\n\n.customer-name { font-weight: 500; line-height: 0.9rem }\n.customer-email { font-weight: 300; color: #888; line-height: 0.9rem; font-size: 0.75rem; }\n\n\n\n/* Compact and Polished Invoice Styles */\n\n.invoice-details.compact {\n  padding: 15px;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.invoice-header h3 {\n  font-size: 1.2em;\n  margin: 0 0 5px 0;\n}\n\n.customer-details h4 {\n  font-size: 1em;\n  color: #0056b3;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n.invoice-link .btn {\n  font-size: 0.85em;\n  padding: 3px 8px;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n\n.orders .order {\n  border: 1px solid #eee;\n  padding: 10px;\n  margin-bottom: 12px;\n  border-radius: 4px;\n}\n\n.order-body {\n  display: flex;\n}\n\n.order-image img {\n  max-height: 100px;\n  width: auto;\n  margin-right: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.order-info p {\n  margin: 4px 0;\n}\n\n.order-lines.compact {\n  font-size: 0.85em;\n}\n\n.order-lines th, .order-lines td {\n  padding: 4px 6px;\n  text-align: left;\n}\n\n.order-lines th {\n  background-color: #f8f9fa;\n}\n\n.invoice-totals p {\n  font-weight: bold;\n  font-size: 1em;\n  margin: 4px 0;\n}\n\n.invoice-totals p strong {\n  width: 150px;\n  display: inline-block;\n}\n\n.payment-result {\n  margin: 10px;\n  border: 1px solid orange;\n  background-color: #781721;\n  color: white;\n  padding: 10px;\n  display: flex;\n}\n\n.payment-result-header {\n  width: 100%;\n  text-align: center;\n  padding: 5px;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 768px) {\n  .invoice-details.compact {\n    font-size: 0.8em;\n  }\n\n  .invoice-header h3 {\n    font-size: 1em;\n  }\n\n  .invoice-totals p strong {\n    width: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
